import {
  FAVORITE_CAMPAIGN_KEY,
  CAMPAIGN_LIST_LAYOUT_KEY,
  PINNED_CAMPAIGN_KEY,
} from "@/helpers/storage";

// Hydrate the campaign-selection keys from localStorage on boot so components can depend
// on the reactive Vuex value directly (e.g. the favorite star reacts to pin/unpin reliably,
// not only after a page reload).
const state = {
  [FAVORITE_CAMPAIGN_KEY]: localStorage.getItem(FAVORITE_CAMPAIGN_KEY),
  [CAMPAIGN_LIST_LAYOUT_KEY]: null,
  [PINNED_CAMPAIGN_KEY]: localStorage.getItem(PINNED_CAMPAIGN_KEY),
};

const mutations = {
  [`SET_${FAVORITE_CAMPAIGN_KEY}`](state, value) {
    state[FAVORITE_CAMPAIGN_KEY] = value;
  },
  [`SET_${CAMPAIGN_LIST_LAYOUT_KEY}`](state, value) {
    state[CAMPAIGN_LIST_LAYOUT_KEY] = value;
  },
  [`SET_${PINNED_CAMPAIGN_KEY}`](state, value) {
    state[PINNED_CAMPAIGN_KEY] = value;
  },
};

const getters = {};
const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
